import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'

// import './bootstrap.css'
import './index.css'
//import reportWebVitals from './reportWebVitals'
import ThemedApp from './common/styles/theme'
import { Security } from '@okta/okta-react'
import OktaAuth from '@okta/okta-auth-js'
import { getIdpProp } from './api/post/postApi'
import { extractDomain, getEntraConfig, getOktaConfig } from './helpers/AuthConfiguration'

const root = ReactDOM.createRoot(document.getElementById('root'));

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.assign(originalUri || '/');
};

// Wrapper component to handle dynamic Okta config
const AppWrapper = () => {
  const [oktaAuth, setOktaAuth] = useState(null);
  const [msalInstance, setMsalInstance] = useState(null);

  useEffect(() => {
    const fetchOktaConfigFromDB = async () => {
      try {
        const domain = {
          Code: extractDomain(window.location.href),
          idpType: 'Okta'
        };
        // const domain = extractDomain('https://first-service-provider.sdc-dev.altigen.com/login');

        // Replace with your actual API call to fetch Okta config from DB
        // const response = await fetch('/api/okta-config');
        const response = await getIdpProp(domain)
        const tableConfig = response.data.result
        // const custtablecomfig = {
        //   issuer: tableConfig?.authorityURL,
        //   clientId: tableConfig.clientId,
        //   redirectUri: window.location.origin+process.env.REACT_APP_OKTA_REDIRECT_URI,
        //   scopes: ['openid', 'profile', 'email'],
        //   pkce: true,
        // };
        const config = getOktaConfig(tableConfig);
        const authInstance = new OktaAuth({
          clientId: config.clientId,
          issuer: config.issuer,
          redirectUri: config.redirectUri,
          scopes: config.scopes,
          pkce: config.pkce,
        });

        setOktaAuth(authInstance);
      } catch (err) {
        const fallbackAuth = new OktaAuth({
          issuer: 'https://example.com',
          clientId: 'dummy',
          redirectUri: window.location.origin,
          scopes: ['openid'],
          pkce: true,
        });

        setOktaAuth(fallbackAuth);
      }
    };
    const fetchEntraConfigFromDB = async () => {
      try {
        const domain = {
          Code: extractDomain(window.location.href),
          idpType: 'entraid'
        };
        const response = await getIdpProp(domain)
        const tableConfig = response.data.result
        const config = getEntraConfig(tableConfig);
        const msalConfig = {
          auth: {
            clientId: config?.clientId,
            authority: config?.authority,
            knownAuthorities: [],
            redirectUri: config?.redirectUri,
            postLogoutRedirectUri: config?.postLogoutRedirectUri,
          },
          cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
          },
        }
        const msalInstance = new PublicClientApplication(msalConfig);
        setMsalInstance(msalInstance);
      } catch (err) {
        const msalConfig = {
          auth: {
            authority: 'https://example.com',
            clientId: 'dummy',
            knownAuthorities: [],
            redirectUri: window.location.origin,
            postLogoutRedirectUri: window.location.origin,
          },
          cache: {
            cacheLocation: 'sessionStorage', // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
          },
        }
        
        const msalInstance = new PublicClientApplication(msalConfig);
        setMsalInstance(msalInstance);
      }
    };

    fetchEntraConfigFromDB();
    fetchOktaConfigFromDB();
  }, []);

  if (!oktaAuth) {
    return <div>Loading authentication...</div>; // fallback UI while fetching config
  }
  if (!msalInstance) {
    return <div>Loading authentication...</div>; // fallback UI while fetching config
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <MsalProvider instance={msalInstance}>
        <ThemedApp />
      </MsalProvider>
    </Security>
  );
};

root.render(<AppWrapper />);